// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wartung und Prüfprotokolle. Every selector is scoped to the page root (also used as
   rootClassName of the module's drawers and dialogs). */

.maintenance-page .mnt-full {
  width: 100%;
}

.maintenance-page .mnt-top {
  margin-top: var(--ds-space-2, 8px);
}

.maintenance-page .mnt-section {
  margin-top: var(--ds-space-4, 16px);
}

.maintenance-page .mnt-section-bottom {
  margin-bottom: var(--ds-space-4, 16px);
}

.maintenance-page .mnt-small {
  font-size: 12px;
  color: var(--ds-text-muted);
  overflow-wrap: anywhere;
}

.maintenance-page .mnt-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.maintenance-page .mnt-empty-text {
  max-width: 520px;
  margin-inline: auto;
}

.maintenance-page .mnt-clickable {
  cursor: pointer;
}

.maintenance-page .mnt-tab-count {
  margin-inline-start: 6px;
}

.maintenance-page .mnt-drawer-footer,
.maintenance-page .mnt-sign-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--ds-space-2, 8px);
}

.maintenance-page .mnt-steps {
  margin-bottom: var(--ds-space-4, 16px);
}

/* Templates */
.maintenance-page .mnt-template-item {
  background: var(--ds-surface-muted, #f6f8fa);
}

.maintenance-page .mnt-template-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--ds-space-2, 8px);
}

/* Visit execution */
.maintenance-page.mnt-visit {
  padding-bottom: 88px;
}

.maintenance-page .mnt-visit-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-2, 8px);
  margin-bottom: var(--ds-space-3, 12px);
}

.maintenance-page .mnt-visit-title h4 {
  margin: 0;
}

.maintenance-page .mnt-hash {
  font-family: "Courier New", monospace;
  font-size: 11px;
  overflow-wrap: anywhere;
}

.maintenance-page .mnt-protocol-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--ds-space-2, 8px);
  white-space: normal;
}

.maintenance-page .mnt-template {
  margin-bottom: var(--ds-space-2, 8px);
}

.maintenance-page .mnt-section-heading {
  margin: var(--ds-space-4, 16px) 0 var(--ds-space-1, 4px);
  font-weight: 600;
  color: var(--ds-heading);
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.04em;
}

.maintenance-page .mnt-item {
  padding: var(--ds-space-3, 12px) 0;
  border-block-end: 1px solid var(--ds-border, #e5e9ee);
  border-inline-start: 3px solid transparent;
  padding-inline-start: var(--ds-space-2, 8px);
}

.maintenance-page .mnt-item-pass {
  border-inline-start-color: var(--ds-success);
}

.maintenance-page .mnt-item-fail {
  border-inline-start-color: var(--ds-danger);
}

.maintenance-page .mnt-item-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--ds-space-2, 8px);
  margin-bottom: var(--ds-space-2, 8px);
}

.maintenance-page .mnt-item-label {
  overflow-wrap: anywhere;
}

.maintenance-page .mnt-optional {
  color: var(--ds-text-muted);
}

/* Three equal, thumb-sized buttons: OK / Mangel / n.a. */
.maintenance-page .mnt-choice {
  display: flex;
  width: 100%;
}

.maintenance-page .mnt-choice .ant-radio-button-wrapper {
  flex: 1 1 0;
  text-align: center;
  min-height: 44px;
}

.maintenance-page .mnt-measure {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-2, 8px);
}

.maintenance-page .mnt-measure-input {
  flex: 1 1 180px;
  max-width: 280px;
}

.maintenance-page .mnt-item-tools {
  margin-top: var(--ds-space-1, 4px);
}

.maintenance-page .mnt-thumbs {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-space-2, 8px);
  margin-top: var(--ds-space-2, 8px);
}

.maintenance-page .mnt-thumbs img {
  object-fit: cover;
  border-radius: 6px;
}

.maintenance-page .mnt-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.maintenance-page .mnt-line {
  margin-bottom: var(--ds-space-2, 8px);
  padding-bottom: var(--ds-space-2, 8px);
  border-block-end: 1px dashed var(--ds-border, #e5e9ee);
}

.maintenance-page .mnt-line-end {
  display: flex;
  justify-content: flex-end;
}

.maintenance-page .mnt-totals {
  margin-top: var(--ds-space-3, 12px);
  text-align: end;
}

/* Save / complete, always in reach of the thumb */
.maintenance-page .mnt-action-bar {
  position: sticky;
  inset-block-end: 0;
  z-index: 5;
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-space-2, 8px);
  padding: var(--ds-space-3, 12px) 0;
  background: var(--ds-surface, #fff);
  border-block-start: 1px solid var(--ds-border, #e5e9ee);
}

@media (max-width: 767px) {
  .maintenance-page .mnt-action-bar {
    inset-block-end: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom));
    padding-inline: var(--ds-space-3, 12px);
    margin-inline: calc(-1 * var(--ds-space-3, 12px));
  }

  .maintenance-page .mnt-action-bar > .ant-btn {
    flex: 1 1 0;
  }

  .maintenance-page .mnt-measure-input {
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/maintenance/maintenance.css"],"names":[],"mappings":"AAAA;wDACwD;;AAExD;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA,cAAc;AACd;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wDAAwD;EACxD,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,qDAAqD;EACrD,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA;EACE;IACE,oEAAoE;IACpE,uCAAuC;IACvC,iDAAiD;EACnD;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Wartung und Prüfprotokolle. Every selector is scoped to the page root (also used as\n   rootClassName of the module's drawers and dialogs). */\n\n.maintenance-page .mnt-full {\n  width: 100%;\n}\n\n.maintenance-page .mnt-top {\n  margin-top: var(--ds-space-2, 8px);\n}\n\n.maintenance-page .mnt-section {\n  margin-top: var(--ds-space-4, 16px);\n}\n\n.maintenance-page .mnt-section-bottom {\n  margin-bottom: var(--ds-space-4, 16px);\n}\n\n.maintenance-page .mnt-small {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n  overflow-wrap: anywhere;\n}\n\n.maintenance-page .mnt-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.maintenance-page .mnt-empty-text {\n  max-width: 520px;\n  margin-inline: auto;\n}\n\n.maintenance-page .mnt-clickable {\n  cursor: pointer;\n}\n\n.maintenance-page .mnt-tab-count {\n  margin-inline-start: 6px;\n}\n\n.maintenance-page .mnt-drawer-footer,\n.maintenance-page .mnt-sign-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: var(--ds-space-2, 8px);\n}\n\n.maintenance-page .mnt-steps {\n  margin-bottom: var(--ds-space-4, 16px);\n}\n\n/* Templates */\n.maintenance-page .mnt-template-item {\n  background: var(--ds-surface-muted, #f6f8fa);\n}\n\n.maintenance-page .mnt-template-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--ds-space-2, 8px);\n}\n\n/* Visit execution */\n.maintenance-page.mnt-visit {\n  padding-bottom: 88px;\n}\n\n.maintenance-page .mnt-visit-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-2, 8px);\n  margin-bottom: var(--ds-space-3, 12px);\n}\n\n.maintenance-page .mnt-visit-title h4 {\n  margin: 0;\n}\n\n.maintenance-page .mnt-hash {\n  font-family: \"Courier New\", monospace;\n  font-size: 11px;\n  overflow-wrap: anywhere;\n}\n\n.maintenance-page .mnt-protocol-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: var(--ds-space-2, 8px);\n  white-space: normal;\n}\n\n.maintenance-page .mnt-template {\n  margin-bottom: var(--ds-space-2, 8px);\n}\n\n.maintenance-page .mnt-section-heading {\n  margin: var(--ds-space-4, 16px) 0 var(--ds-space-1, 4px);\n  font-weight: 600;\n  color: var(--ds-heading);\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.04em;\n}\n\n.maintenance-page .mnt-item {\n  padding: var(--ds-space-3, 12px) 0;\n  border-block-end: 1px solid var(--ds-border, #e5e9ee);\n  border-inline-start: 3px solid transparent;\n  padding-inline-start: var(--ds-space-2, 8px);\n}\n\n.maintenance-page .mnt-item-pass {\n  border-inline-start-color: var(--ds-success);\n}\n\n.maintenance-page .mnt-item-fail {\n  border-inline-start-color: var(--ds-danger);\n}\n\n.maintenance-page .mnt-item-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: var(--ds-space-2, 8px);\n  margin-bottom: var(--ds-space-2, 8px);\n}\n\n.maintenance-page .mnt-item-label {\n  overflow-wrap: anywhere;\n}\n\n.maintenance-page .mnt-optional {\n  color: var(--ds-text-muted);\n}\n\n/* Three equal, thumb-sized buttons: OK / Mangel / n.a. */\n.maintenance-page .mnt-choice {\n  display: flex;\n  width: 100%;\n}\n\n.maintenance-page .mnt-choice .ant-radio-button-wrapper {\n  flex: 1 1 0;\n  text-align: center;\n  min-height: 44px;\n}\n\n.maintenance-page .mnt-measure {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-2, 8px);\n}\n\n.maintenance-page .mnt-measure-input {\n  flex: 1 1 180px;\n  max-width: 280px;\n}\n\n.maintenance-page .mnt-item-tools {\n  margin-top: var(--ds-space-1, 4px);\n}\n\n.maintenance-page .mnt-thumbs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2, 8px);\n  margin-top: var(--ds-space-2, 8px);\n}\n\n.maintenance-page .mnt-thumbs img {\n  object-fit: cover;\n  border-radius: 6px;\n}\n\n.maintenance-page .mnt-thumb {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.maintenance-page .mnt-line {\n  margin-bottom: var(--ds-space-2, 8px);\n  padding-bottom: var(--ds-space-2, 8px);\n  border-block-end: 1px dashed var(--ds-border, #e5e9ee);\n}\n\n.maintenance-page .mnt-line-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.maintenance-page .mnt-totals {\n  margin-top: var(--ds-space-3, 12px);\n  text-align: end;\n}\n\n/* Save / complete, always in reach of the thumb */\n.maintenance-page .mnt-action-bar {\n  position: sticky;\n  inset-block-end: 0;\n  z-index: 5;\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--ds-space-2, 8px);\n  padding: var(--ds-space-3, 12px) 0;\n  background: var(--ds-surface, #fff);\n  border-block-start: 1px solid var(--ds-border, #e5e9ee);\n}\n\n@media (max-width: 767px) {\n  .maintenance-page .mnt-action-bar {\n    inset-block-end: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom));\n    padding-inline: var(--ds-space-3, 12px);\n    margin-inline: calc(-1 * var(--ds-space-3, 12px));\n  }\n\n  .maintenance-page .mnt-action-bar > .ant-btn {\n    flex: 1 1 0;\n  }\n\n  .maintenance-page .mnt-measure-input {\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
